import { useTranslation } from 'react-i18next';

/** A genus as the reader says it (`species.<Genus>` of the reports, in the current language), else the Latin. */
export function useGenusName(): (genus: string) => string {
  const { t } = useTranslation('reports');
  return (genus) => t(`species.${genus}`, { defaultValue: genus });
}
